import Big from 'big.js';

/**
 * Сведения о работе
 */
export class Employment {
    /**
     * Маппинг видов деятельности к их кодам
     */
    static readonly ActivityCode = {
        /** Адвокат */
        attorney: '02',
        /** Пенсионер */
        unemployed_pensioner: '03',
        /** Стандартный */
        default: '04',
        /** ИП */
        soleOwner: '05',
        /** Работник ИП */
        soleOwnerEmployee: '06',
        /** Самозанятый */
        selfEmployed: '07',
    };

    /**
     * Список видов деятельности, при которых требуется ввести номер УНП
     */
    static readonly UNP_OWNERS: string[] = [
        Employment.ActivityCode.soleOwner,
        Employment.ActivityCode.soleOwnerEmployee,
        Employment.ActivityCode.selfEmployed,
    ];

    /**
     * Вид деятельности (цифровой код)
     */
    activityKindCode: string;

    /**
     * УНП
     */
    unp: string;

    /**
     * Сумма дохода
     */
    incomeAmount: Big;

    /**
     * Сфера деятельности (цифровой код)
     * Не указывается, если выбран вид деятельности "Неработающий пенсионер".
     */
    activityFieldCode: string;

    /**
     * Стаж на последнем месте работы (цифровой код)
     * Не указывается, если выбран вид деятельности "Неработающий пенсионер".
     */
    experience: string;

    constructor(
        activityKindCode: string,
        unp: string,
        incomeAmount: Big,
        activityFieldCode: string,
        experience: string,
    ) {
        this.activityKindCode = activityKindCode;
        this.unp = unp;
        this.incomeAmount = incomeAmount;
        this.activityFieldCode = activityFieldCode;
        this.experience = experience;
    }

    static deserialize(data: any) {
        return !!data
            ? new Employment(
                  data.activityKindCode,
                  data.unp,
                  new Big(data.incomeAmount),
                  data.activityFieldCode,
                  data.experience,
              )
            : null;
    }

    /**
     * Проверяет вид деятельности на наличие УНП
     * @param activityCode Код вида деятельности
     * @returns true если у данного вида деятельности предполагается УНП
     */
    static isActivityHasUNP(activityCode: string): boolean {
        if (!activityCode) {
            return false;
        }

        return Employment.UNP_OWNERS.includes(activityCode);
    }
}
